// extracted by mini-css-extract-plugin
module.exports = {"Workflow":"WorkflowSummary_Workflow__3QnY0","Icon":"WorkflowSummary_Icon__KhbEB","Issues":"WorkflowSummary_Issues__1xFVO"};